import { render, staticRenderFns } from "./OffRampChapter.vue?vue&type=template&id=b9d8a32a&"
import script from "./OffRampChapter.vue?vue&type=script&lang=js&"
export * from "./OffRampChapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports